import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { AffinityRule, CreateAffinityPayload } from "../../recommendation.types";
import { requestAddAffinityRule } from "./addAffinityRule.request";

const useAddAffinityRule = (
  options?: MutationOptions<
    AffinityRule,
    ApiServiceError<ApiError>,
    CreateAffinityPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestAddAffinityRule,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "affinity"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useAddAffinityRule;
